import Pill from 'common/components/pills/pill';
import { WebhookStatus } from '../webhook-status';
import { PillTheme } from 'common/components/pills/pill-theme';
import { useUpdateWebhookMutation } from 'app/apis/commandApi';
import { QueryStatus } from '@reduxjs/toolkit/dist/query';
import Spinner, { SpinnerSize } from 'common/components/loading/spinner';
import {
  createUpdateCacheKey,
  createValidationEndpointCacheKey
} from '../webhook-cache-keys';

const getStatusPillTheme = (status: WebhookStatus): PillTheme => {
  switch (status) {
    case WebhookStatus.VALID:
      return PillTheme.SUCCESS;
    case WebhookStatus.INVALID:
      return PillTheme.ERROR;
    case WebhookStatus.DISABLED:
      return PillTheme.DISABLED;
    default:
      throw new Error(
        `Unable to get pill theme from Webhook Status: ${status}`
      );
  }
};

interface WebhookTableStatusProps {
  currentStatus: WebhookStatus;
  webhookId: string;
}

export const WebhooksTableStatus = ({
  currentStatus,
  webhookId
}: WebhookTableStatusProps) => {
  const theme = getStatusPillTheme(currentStatus);

  const [_, updateWebhookMetadata] = useUpdateWebhookMutation({
    fixedCacheKey: createUpdateCacheKey(webhookId)
  });

  const [__, validateWebhookMetadata] = useUpdateWebhookMutation({
    fixedCacheKey: createValidationEndpointCacheKey(webhookId)
  });

  const renderCell = () => {
    if (updateWebhookMetadata.status === QueryStatus.pending) {
      return (
        <div className="flex items-center">
          <Spinner size={SpinnerSize.SMALL} />
          <span className="ml-2 text-sm leading-6">Updating...</span>
        </div>
      );
    } else if (validateWebhookMetadata.status === QueryStatus.pending) {
      return (
        <div className="flex items-center">
          <Spinner size={SpinnerSize.SMALL} />
          <span className="ml-2 text-sm leading-6">Validating Webhook...</span>
        </div>
      );
    } else {
      return (
        <div className="w-21 text-center">
          <Pill theme={theme}>
            <span className="text-sm leading-6">{currentStatus} </span>
          </Pill>
        </div>
      );
    }
  };

  return (
    <div className="flex items-center justify-between relative">
      {renderCell()}
    </div>
  );
};

export default WebhooksTableStatus;
